import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppIdProvider } from "./context/AppIdContext";
import App from "./App";
import "../src/index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppIdProvider>
        <App />
      </AppIdProvider>
    </BrowserRouter>
    {/* <Header/> */}
  </React.StrictMode>
);
